// Uniform objects shared by every VFX material, so the clock and the "Reduce effects" switches update once.

import type { IUniform } from 'three'
import { GLITCH_STEPS_PER_SEC, SHADER_TIME_WRAP_SEC, STATIC_STEPS_PER_SEC } from './timing'

export class VfxUniforms {
  /** Shader clock in seconds, wrapped at SHADER_TIME_WRAP_SEC. */
  readonly uTime: IUniform<number> = { value: 0 }
  /** 1 = glitch / pixel-sort jitter on; 0 under "Reduce effects". */
  readonly uGlitch: IUniform<number> = { value: 1 }
  /** 1 = camera-independent flicker and static animation on; 0 under "Reduce effects". */
  readonly uMotion: IUniform<number> = { value: 1 }
  readonly uGlitchSteps: IUniform<number> = { value: GLITCH_STEPS_PER_SEC }
  readonly uStaticSteps: IUniform<number> = { value: STATIC_STEPS_PER_SEC }

  advance(dtSeconds: number): void {
    this.uTime.value = (this.uTime.value + dtSeconds) % SHADER_TIME_WRAP_SEC
  }

  setReduceEffects(reduce: boolean): void {
    this.uGlitch.value = reduce ? 0 : 1
    this.uMotion.value = reduce ? 0 : 1
  }
}
